import React, { useEffect } from 'react';
import { Wand2, Globe2, Shield, Zap } from 'lucide-react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import ScrollToTop from '../components/ScrollToTop';

export default function AboutPage() {
  useEffect(() => { document.title = 'About | VoiceraLab'; }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <div className="pt-24 pb-16 max-w-4xl mx-auto px-6">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit text-center"><span className="text-gradient">About VoiceraLab</span></h1>
        <p className="text-center text-muted-foreground mt-3 max-w-lg mx-auto">The world's most advanced AI voice platform</p>
        <div className="mt-12 space-y-8">
          <div className="glass-card rounded-2xl p-6 border border-border">
            <h2 className="font-bold font-outfit text-xl text-foreground mb-3">Our Mission</h2>
            <p className="text-muted-foreground leading-relaxed">VoiceraLab was built with a simple mission: make the world's most natural AI voices accessible to everyone. We believe that high-quality voice synthesis should not be limited to large corporations with massive budgets. Our platform democratizes AI voice technology, enabling creators, educators, businesses, and developers to produce studio-quality audio content at a fraction of the traditional cost.</p>
          </div>
          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { icon: <Wand2 className="w-6 h-6" />, title: "204+ AI Voices", desc: "The largest collection of neural voices covering 26+ languages and multiple accents." },
              { icon: <Globe2 className="w-6 h-6" />, title: "Global Reach", desc: "Supporting 26+ languages including English, Chinese, Spanish, French, Arabic, Hindi, and more." },
              { icon: <Shield className="w-6 h-6" />, title: "Enterprise Security", desc: "Bank-level encryption, GDPR compliant, and SOC 2 certified infrastructure." },
              { icon: <Zap className="w-6 h-6" />, title: "Lightning Fast", desc: "Generate hours of audio in minutes with our optimized neural synthesis engine." },
            ].map((item, i) => (
              <div key={i} className="glass-card rounded-xl p-5 border border-border">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary mb-3">{item.icon}</div>
                <h3 className="font-semibold text-foreground">{item.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}
